export { default } from "./MainIdeaOrganizer";
